export default __webpack_public_path__ + "static/media/tiger.4e46895e.ogg";